import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin, Tooltip, Select } from "antd";
import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest } from "../../axios";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
const { Option } = Select;

const AssignCityVendorStep = ({
  state,
  setState,
  companyId,
  VendorId,
  data,
}) => {
  const formRef = useRef();
  const { t } = useTranslation();

  const colors = ["#0000"];
  const [apiLoading, setapiloading] = useState(false);
  const [materialType, setMaterialType] = useState([]);
  const [cityDropdownOptionsAddVendor, setCityDropdownOptionsAddVendor] =
    useState([]);
  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.assign_city_to_vendor;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, assign_city_to_vendor: newPersonArr });
  };
  useEffect(() => {
    // getMaterialTypeByCategory();
    getCitye();
  }, [companyId]);
  const getCitye = async () => {
    await getRequest(
      `vendor-assign-city/city-by-site/?company_id=${companyId}`
    ).then((response) => {
      //setCityDropdownOptions(response.data.data);
      setCityDropdownOptionsAddVendor(response.data.data);
      console.log("piiiu", response.data.data);
    });
  };
  // const getMaterialTypeByCategory = async (categoryId) => {
  //     try {
  //         const materialTypeResponse = await getRequest(
  //             `material-type/?category_tree_id=${1}`
  //         );

  //         setMaterialType(materialTypeResponse.data.results.data);
  //     } catch (error) {
  //         console.error("Error fetching material types:", error);
  //     }
  // };

  // const handleMaterialChange = (index, value) => {
  //     const updatedAssignCity = [...state.assign_city_to_vendor];
  //     updatedAssignCity[index].material_type = value;
  //     setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  // };

  // const [materialType, setMaterialType] = useState([]);
  const [selectedMaterialTypes, setSelectedMaterialTypes] = useState({});

  useEffect(() => {
    getMaterialTypeByCategory();
  }, [companyId]);

  useEffect(() => {
    const initializeSelectedMaterials = () => {
      const selectedMaterials = {};
      state.assign_city_to_vendor.forEach((item, index) => {
        selectedMaterials[index] = item.material_type;
      });
      setSelectedMaterialTypes(selectedMaterials);
    };

    if (state.assign_city_to_vendor) {
      initializeSelectedMaterials();
    }
  }, [state.assign_city_to_vendor]);

  const getMaterialTypeByCategory = async () => {
    // const response = await getRequest(`material-type/?category_tree_id=1`);
    const response = await getRequest(
      `company-material-code/1/get-company-material/`
    );

    const materialTypes = response.data.data;

    setMaterialType(materialTypes);
  };

  //   const handleMaterialChange = (index, value) => {
  //     const updatedAssignCity = [...state.assign_city_to_vendor];

  //     const selectedMaterial = filteredMaterialTypes.find(
  //       (item) => item.id === value
  //     );

  //     if (selectedMaterial) {
  //       updatedAssignCity[index].material_type = selectedMaterial.id;
  //       updatedAssignCity[index].material_type_name = selectedMaterial.type_name;
  //     }

  //     setState({ ...state, assign_city_to_vendor: updatedAssignCity });

  //     // Update selected material types
  //     setSelectedMaterialTypes((prevSelected) => ({
  //       ...prevSelected,
  //       [index]: value,
  //     }));

  //     // updatedAssignCity[index].material_type = value;
  //     // updatedAssignCity[index].material_type_name = value;
  //     // setState({ ...state, assign_city_to_vendor: updatedAssignCity });

  //     // Update selected material types
  //     // setSelectedMaterialTypes((prevSelected) => ({ ...prevSelected, [index]: value }));
  //   };

  const filteredMaterialTypes = materialType.filter((material) => {
    return !Object.values(selectedMaterialTypes).includes(material.id);
  });

  //   let filteredMaterialTypes = [];

  //   if (VendorId) {
  //     console.log("selectedMaterialTypes 5 ", selectedMaterialTypes);
  //     console.log("state 5 ", state.assign_city_to_vendor);

  //     filteredMaterialTypes = state.assign_city_to_vendor.filter((material) => {
  //       return !Object.values(selectedMaterialTypes).includes(material.id);
  //     });
  //   } else {
  //     filteredMaterialTypes = materialType.filter((material) => {
  //       return !Object.values(selectedMaterialTypes).includes(material.id);
  //     });
  //   }

  //   const filteredMaterialTypes = materialType.filter((material) => {
  //     return !Object.values(selectedMaterialTypes).includes(material.id);
  //   });

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["material_type" + objectKey] = objectValue.material_type_name;
      fieldObject["city" + objectKey] = objectValue.city;
      fieldObject["state" + objectKey] = objectValue.state;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.assign_city_to_vendor;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, assign_city_to_vendor: newPersonArr });
  };

  useEffect(() => {
    if (companyId) {
      const modifiedInquiry = state.assign_city_to_vendor.map(
        (inquiryDetail) => {
          const { id, company, company_name, ...rest } = inquiryDetail;
          return rest;
        }
      );

      setWeightSizeInquiryFieldValueCity(modifiedInquiry);
    }
  }, [state, companyId, t]);
  const handleCityChangeSite = (field, index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].city = value;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };
  const setWeightSizeInquiryFieldValueCity = (data) => {
    console.log("data", data);
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["category_tree" + objectKey] = objectValue.category_tree;
      fieldObject["material_type" + objectKey] = objectValue.material_type_name;
      fieldObject["city" + objectKey] = objectValue.city;
      // fieldObject["state" + objectKey] = objectValue.state;

      // fieldObject["gst_number" + objectKey] = objectValue.gst_number;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  // const addInquiryCity = () => {
  //     const newPersonArr = {
  //         company: companyId,
  //         category_tree: 1,
  //         material_type: null,
  //         city: null,
  //         state: null,
  //         gst_number: null,
  //     };
  //     setState({
  //         ...state,
  //         assign_city_to_vendor: [...state.assign_city_to_vendor, newPersonArr],
  //     });
  //     setWeightSizeInquiryFieldValueCity(newPersonArr);
  // };

  const addInquiryCity = () => {
    let newPersonArr = [
      ...state.assign_city_to_vendor,
      {
        company: companyId,
        category_tree: 1,
        material_type: null,
        city: [],
      },
    ];
    setState({ ...state, assign_city_to_vendor: newPersonArr });
    setWeightSizeInquiryFieldValueCity(newPersonArr);
  };
  // const removeInquiryCity = (lastIndex) => {
  //     const updatedAssignCity = state.assign_city_to_vendor.filter(
  //         (item, index) => index !== lastIndex
  //     );
  //     setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  //     setWeightSizeInquiryFieldValueCity(updatedAssignCity);
  // };

  const removeInquiryCity = (lastIndex) => {
    const updatedAssignCity = state.assign_city_to_vendor.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
    setWeightSizeInquiryFieldValueCity(updatedAssignCity);
    setSelectedMaterialTypes((prevSelected) => {
      const updatedSelected = { ...prevSelected };
      delete updatedSelected[lastIndex];
      return updatedSelected;
    });
  };
  const handleMaterialChange = (index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];

    const selectedMaterial = materialType.find((item) => item.id === value);

    if (selectedMaterial) {
      updatedAssignCity[index].material_type = selectedMaterial.id;
      updatedAssignCity[index].material_type_name = selectedMaterial.type_name;
    }

    setState({ ...state, assign_city_to_vendor: updatedAssignCity });

    // Update selected material types
    setSelectedMaterialTypes((prevSelected) => ({
      ...prevSelected,
      [index]: value,
    }));
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form onFinish={""} autoComplete="off" ref={formRef}>
          {state.assign_city_to_vendor &&
            state.assign_city_to_vendor.map((x, index) => {
              return (
                <>
                  <Row key={index} className="customcol" gutter={[15]}>
                    <Col xs={24} sm={12} md={8} xl={5} xxl={5}>
                      <Form.Item
                        // name={`material_type_${index}`}
                        label={t("Material Type")}
                        name={`material_type` + index}
                        // value={state.material_type}
                        // initialValue={x.material_type}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Select material type")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          showSearch
                          // value={x.material_type}
                          allowClear
                          placeholder={t("pl_material_type")}
                          onChange={(value) =>
                            handleMaterialChange(index, value)
                          }
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          // onChange={(value) =>
                          //     handleMaterialChange(
                          //         "material_type",
                          //         value,
                          //         index
                          //     )
                          // }

                          optionFilterProp="children"
                        >
                          {/* {materialType &&
                                                                materialType.length > 0 &&
                                                                materialType.map((item) => (
                                                                    <Select.Option
                                                                        key={item.id}
                                                                        value={item.id}
                                                                    >
                                                                        {item.type_name}
                                                                    </Select.Option>
                                                                ))} */}
                          {filteredMaterialTypes.map((material) => (
                            <Option key={material.id} value={material.id}>
                              {material.type_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} xl={5} xxl={5}>
                      <Form.Item name={`city` + index} label={t("pl_city")}>
                        <Select
                          mode="multiple"
                          showArrow
                          showSearch
                          optionFilterProp="children"
                          placeholder={t("place_city")}
                          onChange={(value) =>
                            handleCityChangeSite("city", index, value)
                          }
                          prefix={<ZipCode />}
                        >
                          {/* {cityDropdownOptions.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))} */}
                          {cityDropdownOptionsAddVendor.map((item) => (
                            <Select.Option
                              key={item.city_id}
                              value={item.city_id}
                            >
                              {item.city_name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <div className="addwrp">
                      <Space>
                        {index !== 0 && (
                          <MinusSquareFilled
                            className="add"
                            onClick={() => removeInquiryCity(index)}
                          />
                        )}
                        <PlusSquareFilled
                          className="add"
                          onClick={addInquiryCity}
                        />
                      </Space>
                    </div>
                  </Row>
                </>
              );
            })}
        </Form>
      </Spin>
    </>
  );
};
AssignCityVendorStep.propTypes = {
  state: PropTypes.func,
  setState: PropTypes.func,
  companyId: PropTypes.number,
  VendorId: PropTypes.number,

  data: PropTypes.func,
};
export default AssignCityVendorStep;
